import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import AdminMenu from '../Modules/AdminMenu';
import Api from '../../Global/Modules/Api'

class AdminIndex extends Component {
  constructor() {
    super();

  }


  render() {
    const wellStyles = { maxWidth: 400, margin: '0 auto 10px' };

    return (
      <div className="route">
        <AdminMenu />
        <h1 className="pageTitle">
          Webmanager
          </h1>
        <div className="well" style={wellStyles}>
          <LinkContainer to="/admin/leden">
            <Button bsSize="large" block>
              Leden overzicht
              </Button>
          </LinkContainer>
          <LinkContainer to="/admin/leden/toevoegen">
            <Button bsSize="large" block>
              Lid toevoegen
              </Button>
          </LinkContainer>
          <LinkContainer to="/admin/leden/groepen">
            <Button bsSize="large" block>
              Groepen overzicht
              </Button>
          </LinkContainer>
          <LinkContainer to="/admin/leden/groepen/toevoegen">
            <Button bsSize="large" block>
              Groep toevoegen
              </Button>
          </LinkContainer>
        </div>
      </div>
    );
  }
}

export default AdminIndex;



// WEBPACK FOOTER //
// ./src/components/Admin/Pages/Index.js